import { REMEMBER_ME_COOKIE_NAME } from './common'

/** next/headers `cookies()`와 미들웨어 `request.cookies`를 모두 받는다 */
interface ICookieStore {
  get: (name: string) => { value: string } | undefined
}

const REMEMBER_ME_PREFIX = `${REMEMBER_ME_COOKIE_NAME}=`

/** 앱이 `remember-me=<값>` 형태로 통째로 넣어주는 경우가 있어 접두사를 벗기고, 비어 있으면 undefined */
export const getRememberMeToken = (
  cookieStore: ICookieStore
): string | undefined => {
  const value = cookieStore.get(REMEMBER_ME_COOKIE_NAME)?.value ?? ''
  const token = value.startsWith(REMEMBER_ME_PREFIX)
    ? value.slice(REMEMBER_ME_PREFIX.length)
    : value

  return token || undefined
}

/** 비로그인·외부 진입에서도 공개 데이터를 조회하도록 사용자 토큰이 없으면 서비스 계정 토큰을 쓴다 */
export const resolveRememberMeOrServiceToken = (
  cookieStore: ICookieStore
): string | undefined =>
  getRememberMeToken(cookieStore) ?? process.env.PLACE_LIST_API_REMEMBER_ME

export const getCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') {
    return undefined
  }

  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2) {
    return parts.pop()?.split(';').shift()
  }

  return undefined
}
